function encodeSpacesInURL(url) {
  if (typeof url === 'string' && url !== undefined && url !== null) {
    return url.replace(/ /g, '%20');
  }
}
function checkPath(path) {
  // Kiểm tra nếu path là chuỗi hợp lệ
  if (typeof path === 'string' && path !== undefined && path !== null) {
    return path.includes("/Uploads/LDLawyer/");
  }
  return false; // Nếu không phải chuỗi hợp lệ, trả về false
}

const LinkUpload = (action) => {
  const statisLink = `https://doanluatsulamdong.org.vn:8800/`
  return encodeSpacesInURL(statisLink + action)
}
export default LinkUpload